async function fetchData(url, onError, set_origin) {
  // Check if process is defined and we're in a testing environment
  set_origin = typeof set_origin !== 'undefined'

  let fullUrl = url

  if (
    typeof window !== 'undefined' &&
    window.location.hostname.indexOf('visualsforbrands.com') !== -1
  ) {
    fullUrl = `https://api.rbt-viewer.visualsforbrands.com${url}`
  }

  try {
    let request_info = {}

    if (set_origin) {
      let custom_origin = 'http://localhost:3000'

      if (typeof window !== 'undefined') {
        if (window.location.hostname.indexOf('rbt-viewer.') !== -1) {
          custom_origin = 'https://rbt-viewer.visualsforbrands.com'
        } else if (window.location.hostname.indexOf('rbt-viewer-dev.') !== -1) {
          custom_origin = 'https://rbt-viewer-dev.visualsforbrands.com'
        }
      }

      request_info.headers = {
        customorigin: custom_origin,
      }
    }
    const response = await fetch(fullUrl, request_info)
    if (!response.ok) {
      return false
    }
    return await response.json()
  } catch (error) {
    console.error(`Error fetching data from ${fullUrl}:`, error)
    onError && onError(error)
    throw error
  }
}

export function retrieveProduct(productModelID) {
  console.log('📞 hellooooo craftzingggg (dato api)')
  return fetchData(`/api/viewer/${productModelID}`, false, true)
}

export const fetchProductData = async (modelId) => {
  // Current model is a set
  const modelIsSet = modelId.indexOf('SET') !== -1

  // Retrieve the main product data
  const productDataResponse = await retrieveProduct(modelId)

  console.log(`👀 dato response: `, productDataResponse)

  // Initialize xsells as an empty array if there aren't any
  let xsells = []

  let xsells_dato = []

  if (productDataResponse?.crossSelling?.length) {
    productDataResponse.crossSelling.forEach((xsell) => {
      xsells.push(xsell.baseModel)
      xsells_dato.push({
        code: xsell.baseModel.code,
        parent: false,
      })
    })
  }

  // sets flattenen
  if (productDataResponse?.items?.length && modelIsSet) {
    productDataResponse.items.forEach((item) => {
      // basemodel, zonder crossSelling
      if (item?.baseModel?.code && item?.baseModel?.variants) {
        if (
          xsells.findIndex(
            (product) => product.code === item.baseModel.code,
          ) === -1
        ) {
          xsells.push({
            code: item.baseModel.code,
            variants: item.baseModel.variants,
          })
          xsells_dato.push({
            code: item.baseModel.code,
            parent: false,
          })
        } else {
          console.log(`👀 Dato duplicate detected for: ${item.baseModel.code}`)
        }
      }

      // xsells van elk model
      if (item?.baseModel?.crossSelling?.length) {
        item.baseModel.crossSelling.forEach((item_xsell) => {
          if (
            xsells.findIndex(
              (product) => product.code === item_xsell.baseModel.code,
            ) === -1
          ) {
            xsells.push({
              code: item_xsell.baseModel.code,
              variants: item_xsell.baseModel.variants,
            })
            xsells_dato.push({
              code: item_xsell.baseModel.code,
              parent: item.baseModel.code,
            })
          } else {
            console.log(
              `👀 Dato duplicate detected for: ${item_xsell.baseModel.code}`,
            )
          }
        })
      }
    })
  }

  console.log(`👀 Dato xsells`, [...xsells_dato])

  // xsell renamen als het om de alura gaat en pillows heeft
  // const alura_regex = /ALRL[01]\d[A-Z]/g
  // if (alura_regex.test(modelId) && xsells.length) {
  //   // wat is de laatste letter van het id?
  //   let modelid_last_letter = modelId.substring(modelId.length - 1)
  //   xsells.forEach((xsell, index) => {
  //     if (xsell.code.indexOf('PIL') !== -1) {
  //       let xsellid_last_two_letters = xsell.code.substring(
  //         xsell.code.length - 2,
  //       )
  //       let xsellid_last_four_letters = xsell.code.substring(
  //         xsell.code.length - 4,
  //       )
  //       if (
  //         xsellid_last_two_letters === 'AB' ||
  //         xsellid_last_four_letters === '16CD'
  //       ) {
  //         // indien xsell eindigt op 'AB', kijk naar de laatste letter en vervang AB met die laatste letter
  //         xsells[index].code =
  //           xsells[index].code.substring(0, xsells[index].code.length - 2) +
  //           modelid_last_letter
  //       } else if (xsellid_last_two_letters !== 'CD') {
  //         // voeg laatste letter van model toe aan xsell id (als de twee laatste letters van de xsell niet CD zijn
  //         xsells[index].code = xsells[index].code + modelid_last_letter
  //       }
  //     } else if (xsell.code === 'ALRL80TOPC') {
  //       xsell.code = modelId + '_' + xsell.identifier
  //     }
  //   })
  // }

  // Construct the main product model
  let constructedProductModel = constructProductData(productDataResponse)

  // Add cross-sell data to the constructed product model
  constructedProductModel.crossSellData = xsells.map((xsell) =>
    constructProductData(xsell),
  )

  return [constructedProductModel]
}

function findProductIndexByIdentifier(products, product_id_to_find) {
  return products.findIndex((product) => product.code === product_id_to_find)
}

function spliceProductsFromArray(products, array) {
  products.forEach((id) => {
    let searched_index = array.indexOf(id)

    if (searched_index !== -1) {
      array.splice(searched_index, 1)
    }
  })
}

function spliceProductsFromObjectArray(products, array) {
  products.forEach((product) => {
    let searched_index = findProductIndexByIdentifier(array, product)

    if (searched_index !== -1) {
      array.splice(searched_index, 1)
    }
  })
}

export function constructProductData(productData) {
  let productMaterials = deconstructMaterialIds(productData.variants)

  // Combine axesMaterials and staticMaterials into a single array
  let materialData = [
    ...productMaterials.axesMaterials,
    ...productMaterials.staticMaterials,
  ]

  materialData = removeDuplicateArrays(materialData)

  return {
    modelCode: productData.code,
    materialData: materialData,
  }
}

function deconstructMaterialIds(variants) {
  let materialsByType = {
    axesMaterials: {},
    staticMaterials: {},
  }

  if (typeof variants === 'undefined') {
    variants = []
  }

  variants.forEach((variant) => {
    // Process axes_map materials
    Object.values(variant.metadata.axesMap).forEach((material) => {
      // if (material.axesMapType === 'batyline_colour') {
      //   material.axesMapType = 'colour_batyline'
      // }
      // if (material.axesMapType === 'pole_material_colour') {
      //   material.axesMapType = 'frame_material_colour'
      // }
      if (!materialsByType.axesMaterials[material.axesMapType]) {
        materialsByType.axesMaterials[material.axesMapType] = []
      }
      if (
        !materialsByType.axesMaterials[material.axesMapType].some(
          (existingMaterial) =>
            existingMaterial.id === material.material.materialId,
        )
      ) {
        materialsByType.axesMaterials[material.axesMapType].push({
          id: material.material.materialId,
          code: material.axesMapCode,
          label: material.axesMapLabel,
          type: material.axesMapType,
          material: material.material,
        })
      }
    })

    // Process staticMaterials
    if (variant.metadata.staticMaterials) {
      variant.metadata.staticMaterials.forEach((material) => {
        if (!materialsByType.staticMaterials[material.reference]) {
          materialsByType.staticMaterials[material.reference] = []
        }
        if (
          !materialsByType.staticMaterials[material.reference].some(
            (existingMaterial) => existingMaterial.id === material.materialId,
          )
        ) {
          materialsByType.staticMaterials[material.reference].push({
            id: material.materialId,
            code: material.code,
            type: material.reference,
            material: material,
          })
        }
      })
    }
  })

  return {
    axesMaterials: Object.values(materialsByType.axesMaterials).flat(),
    staticMaterials: Object.values(materialsByType.staticMaterials).flat(),
  }
}

function removeDuplicateArrays(materialData) {
  const uniqueMaterials = []
  const materialKeys = new Set()

  materialData.forEach((material) => {
    const key = `${material.code}-${material.type}`
    if (!materialKeys.has(key)) {
      materialKeys.add(key)
      uniqueMaterials.push(material)
    }
  })

  return uniqueMaterials
}
